module.exports = __webpack_public_path__ + "img/dark-mode-icon-dark.9b19ce04.svg";